import { ComponentContent } from "../../types/stocks";
import RecentlyViewedContainer from "./RecentlyViewedContainer";

interface RecentlyViewedProps {
  content?: ComponentContent;
}

export const RecentlyViewed = ({ content }: RecentlyViewedProps) => (
  <RecentlyViewedContainer content={content} />
);

export default RecentlyViewed;
